import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';

import styles from './post-list.scss';

const renderItem = (props) => {
  const { post, ItemComponent, itemProps, layoutName, index } = props;
  const wrapperClass = classNames(styles.listItemMobile, styles[layoutName], 'post-list__post-list-item');

  return (
    <div className={wrapperClass} key={post._id} id={post._id}>
      <ItemComponent post={post} {...itemProps} index={index} />
    </div>
  );
};

renderItem.propTypes = {
  post: PropTypes.any,
  ItemComponent: PropTypes.func,
  itemProps: PropTypes.object,
  layoutName: PropTypes.string,
  index: PropTypes.number,
};

const PostListMobile = (props) => (
  <Fragment>{props.posts.map((post, index) => renderItem({ ...props, post, index }))}</Fragment>
);

PostListMobile.propTypes = {
  posts: PropTypes.array,
  ItemComponent: PropTypes.func.isRequired,
  itemProps: PropTypes.object.isRequired,
  layoutName: PropTypes.string.isRequired,
  isMobileLayoutUpdatedStylesExperimentEnabled: PropTypes.bool,
};

export default PostListMobile;
